export const STRIPE = {
  CREATE_PAYMENT_INTENT: 'CREATE_PAYMENT_INTENT',
  CREATE_PAYMENT_INTENT_SUCCESS: 'CREATE_PAYMENT_INTENT_SUCCESS',
  CREATE_PAYMENT_INTENT_FAIL: 'CREATE_PAYMENT_INTENT_FAIL'
};
